<main>
  <loading-overlay [isLoading]="isLoading > 0" />
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'YarnsQc_Title' | translateWF: 'Yarns Quality Control' }}</h1>
        <div class="page__title_buttons">
          <p-button [label]="'YarnsQc_CreateYarnQC' | translateWF: 'Create Yarn QC'" variant="outlined" icon="pi pi-plus" (onClick)="redirectToDetail('new')" />
        </div>
      </div>
    </div>

    <section>
      <p-selectButton [options]="views" [(ngModel)]="selectedView" optionLabel="label" optionValue="value" />
    </section>

    @switch (selectedView) {
      @case (1) {
        <section>
          <p-table [value]="yarnsQC()">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'YarnsQc_ID' | translateWF: 'Yarn QC ID' }}</th>
                <th>{{ 'YarnsQc_Invoice' | translateWF: 'Invoice' }}</th>
                <th>{{ 'YarnsQc_Shipment' | translateWF: 'Shipment' }}</th>
                <th>{{ 'YarnsQc_Provider' | translateWF: 'Provider' }}</th>
                <th>{{ 'YarnsQc_Lot' | translateWF: 'Lot' }}</th>
                <th>{{ 'YarnsQc_Item' | translateWF: 'Item' }}</th>
                <th>{{ 'YarnsQc_Link' | translateWF: 'Link' }}</th>
                <th>{{ 'YarnsQc_Conditional' | translateWF: 'Conditional' }}</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-yarnsQC>
              <tr>
                <td class="cursor-pointer" (click)="redirectToDetail(yarnsQC.id)">
                  <a>
                    @if (yarnsQC.number) {
                      {{ yarnsQC.number }}
                    } @else {
                      -----
                    }
                  </a>
                </td>
                <td>{{ getInvoiceName(yarnsQC.invoiceReference) }}</td>
                <td>{{ getShipmentByInvoiceReference(yarnsQC.invoiceReference) }}</td>
                <td>{{ getProvider(yarnsQC.invoiceReference) }}</td>
                <td>{{ yarnsQC.itemCodeKeyWithResults[0].itemCode }}</td>
                <td>{{ getYarnByItemMaster(yarnsQC.itemCodeKeyWithResults?.[0]?.itemCode) }}</td>
                <td>
                  @if (yarnsQC.supportingDocuments.length > 0) {
                    <a class="font-semibold text-blue-500" target="_blank" [href]="yarnsQC.supportingDocuments[0].presignedUrl">
                      {{ 'YarnsQc_DocumentQC' | translateWF: 'Document QC' }}
                    </a>
                  } @else {
                    {{ 'YarnsQc_NoDocument' | translateWF: 'No Document' }}
                  }
                </td>
                <td></td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
      @case (2) {
        <section>
          <p-table>
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'YarnsQc_Link' | translateWF: 'Link' }}</th>
                <th>{{ 'YarnsQc_Conditional' | translateWF: 'Conditional' }}</th>
                <th></th>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
    }
  </div>
</main>
